import * as React from 'react';

const NotFound = () => {
   return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
         <h1>Sorry, the page you visited does not exist.</h1>
      </div>
   );
}

export default NotFound;
